// One compact, single-line visual size for CRM labels and editable tag chips.
// The surrounding form field can remain larger for touch input.
export const crmTagClassName = "inline-flex h-[22px] min-w-0 max-w-full items-center gap-1 whitespace-nowrap px-1.5 py-0 text-xs leading-4";

export const crmTagRemoveClassName = "-mr-0.5 inline-flex h-6 w-6 shrink-0 touch-manipulation items-center justify-center rounded-full hover:bg-destructive/10 hover:text-destructive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary";
